export default __webpack_public_path__ + "static/media/19.8a749cb4.jpg";